
const defaultExport = {
  props: {
    launch: {
      type: Object,
      default: null
    }
  },
  methods: {
    convertDate(dateString) {
      const dt = new Date(dateString);
      return dt.toLocaleString();
    },
    toDetails() {
      this.$router.push({
        name: 'MissionDetails',
        params: { id: this.launch.id }
      });
    }
  }
};

import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "../../_snowpack/pkg/vue.js"

const _hoisted_1 = ["id", "src"]
const _hoisted_2 = ["id", "src"]
const _hoisted_3 = { class: "card-body bg-dark bg-gradient text-white rounded-bottom" }
const _hoisted_4 = { class: "row d-flex align-items-center" }
const _hoisted_5 = { class: "col-lg-3 d-xl-block d-none" }
const _hoisted_6 = ["id", "src"]
const _hoisted_7 = ["id", "src"]
const _hoisted_8 = { class: "col-9" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "card-text" }
const _hoisted_11 = { class: "card-text text-muted" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: "card h-100 border-0 shadow",
    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toDetails && _ctx.toDetails(...args)))
  }, [
    _createElementVNode("div", null, [
      (_ctx.launch.links.flickr_images.length)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            id: _ctx.launch.links.flickr_images[0],
            src: _ctx.launch.links.flickr_images[0],
            alt: "mission image",
            class: "card-img-top",
            style: {"height":"25vw","object-fit":"cover"}
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            id: _ctx.launch.links.mission_patch,
            src: _ctx.launch.links.mission_patch,
            alt: "mission patch",
            class: "card-img-top",
            style: {"height":"25vw","object-fit":"contain"}
          }, null, 8, _hoisted_2))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.launch.links.mission_patch_small)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                id: _ctx.launch.links.mission_patch_small,
                src: _ctx.launch.links.mission_patch_small,
                alt: "mission patch small",
                style: {"width":"7.5vh","height":"7.5vh","object-fit":"contain"}
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                id: _ctx.launch.links.flickr_images[0],
                src: _ctx.launch.links.flickr_images[0],
                alt: "launch image",
                style: {"width":"7.5vh","height":"7.5vh","object-fit":"cover"}
              }, null, 8, _hoisted_7))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.launch.mission_name), 1),
          _createElementVNode("div", _hoisted_10, "Rocket: " + _toDisplayString(_ctx.launch.rocket.rocket_name), 1),
          _createElementVNode("div", _hoisted_11, " Launch Date: " + _toDisplayString(_ctx.convertDate(_ctx.launch.launch_date_utc)), 1)
        ])
      ])
    ])
  ]))
};

defaultExport.render = render;

export default defaultExport;